/**
 * Custom Quick Add
 * ----------------------------------------------------------------------
 * Renders an always-visible row of size cells at the bottom of each
 * product card image (collection/grid pages). Tapping a size adds that
 * variant to the cart via the standard Shopify AJAX Cart API.
 *
 * The store's cart drawer is provided by a third-party app (Opus), which
 * auto-detects standard /cart/add.js requests and opens itself — so this
 * script intentionally does NOT try to open any drawer manually. It just
 * performs a clean, standard add-to-cart request.
 */
(function () {
  var ADD_URL = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';

  function setStatus(root, show, text) {
    var status = root.querySelector('[data-cqa-status]');
    if (!status) return;

    if (show && text) {
      var textEl = status.querySelector('[data-cqa-status-text]');
      if (textEl) textEl.textContent = text;
    }

    root.classList.toggle('custom-quick-add--adding', !!show);
  }

  function handleSizeClick(evt) {
    var sizeBtn = evt.target.closest('[data-cqa-size]');
    if (!sizeBtn || sizeBtn.disabled) return;
    evt.preventDefault();

    var root = sizeBtn.closest('[data-custom-quick-add]');
    if (!root) return;

    var variantId = sizeBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    setStatus(root, true, 'Adding...');

    fetch(ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var message = (data && (data.description || data.message)) || 'Could not add to cart';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function () {
        // Success — let the store's cart drawer app (Opus) detect the
        // standard cart/add.js request and open itself. Also notify any
        // theme listeners that the cart changed, in case other widgets
        // (cart item counters, etc.) want to refresh.
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: variantId } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { variantId: variantId } }));

        setStatus(root, false);
      })
      .catch(function (error) {
        setStatus(root, true, (error && error.message) || 'Sold out');
        setTimeout(function () {
          setStatus(root, false);
        }, 1800);
      });
  }

  document.addEventListener('click', function (evt) {
    if (evt.target.closest('[data-cqa-size]')) {
      handleSizeClick(evt);
    }
  });
})();